import { MarketingSEO } from '@/components/seo/MarketingSEO'
import IphoneMonitoringTopicTemplate from '@/components/IphoneMonitoringTopicTemplate'
import { iphoneMonitoringTopics } from '@/data/iphoneMonitoringTopics'

const topic = iphoneMonitoringTopics.find((t) => t.slug === 'youtube-google')!
const related = iphoneMonitoringTopics.filter((t) => t.slug !== 'youtube-google')

export default function IPhoneMonitoringYouTubeGoogle() {
  const canonicalUrl = 'https://www.joeyfamily.com/features/iphone-monitoring/youtube-google'
  return (
    <>
      <MarketingSEO
        title={topic.title}
        description={topic.seoDescription}
        url={canonicalUrl}
        image="/img/og/joey-default-1200x630.png"
        noindex
      />
      <IphoneMonitoringTopicTemplate topic={topic} relatedTopics={related} />
    </>
  )
}

